import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoaderService } from '../../../core/services/loader/loader.service';
import { NotificationService } from '../../../core/services/notification/notification.service';
import { CommonService } from '../../services/common/common.service';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';

@Component({
  selector: 'app-release-log',
  templateUrl: './release-log.component.html',
  styleUrls: ['./release-log.component.css']
})


export class ReleaseLogComponent implements OnInit {
  releaseNoteList!: any[];
  pageIndex = 0;
  take: number = 5;
  skip: number = 0;
  HideNextLink: boolean = false;
    userRole: string;
    ReleaseSource: string;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,public dialog: MatDialog,private commonServices: CommonService,
    private dialogRef: MatDialogRef<ReleaseLogComponent>,
    private loader: LoaderService,
    private notificationService: NotificationService,
    private errorhandlerService: ErrorhandlerService) {
    this.releaseNoteList = [];
  }

  ngOnInit() {
    this.userRole = localStorage.getItem('role');
    this.fn_OlderRelese(this.data);
  }

  fn_OlderRelese(IsShopify: boolean) {
    this.ReleaseSource = null;
    this.skip = this.take * this.pageIndex
    this.commonServices.getAllReleaseNoteList(this.take, this.skip, IsShopify).subscribe((res: any) => {
      if (res.StatusCode == 200) {
        res.Data.ResponseData.forEach((obj: any) => {
          this.releaseNoteList.push(obj);
        });
        this.ReleaseSource = "Merchloop";
        this.pageIndex++;
        if (res.Data.ResponseData.length < this.take)
          this.HideNextLink = true;
        else
          this.HideNextLink = false;

          if(!this.releaseNoteList && this.releaseNoteList.length == 0){
            this.fn_DismissReleaseNote();
          }
      }
    }, err => {
      this.loader.hide();
      this.errorhandlerService.handleError(err);
    });
  }

  fn_DismissReleaseNote() {
    this.loader.show();
    this.commonServices.dismissReleaseNote().subscribe((res: any) => {
      if (res.StatusCode == 200) {
       
      }
      else {
        this.notificationService.error(res.Message, "Error");
      }
      this.loader.hide();
    }, err => {
      this.loader.hide();
      this.errorhandlerService.handleError(err);
    });
  }

  fn_EditReleaseNote(note: any) {
    this.dialogRef.close({ data: note });
  }
}
